import {Component, OnInit, Inject, ViewEncapsulation, OnDestroy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents} from '@irb-common/events';
import { ImportBlendedModelsResultGridLayoutService } from '@irb/irb-models/import-blended-model-result-dialog/import-blended-model-result.grid-layout.service';
import { ModelsService } from '@irb/irb-models//models-new/models.service';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-import-blended-model-result-dialog',
  templateUrl: './import-blended-model-result-dialog.component.html',
  styleUrls: ['./import-blended-model-result-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportBlendedModelsResultDialogComponent implements OnInit, OnDestroy {
  grid: any;
  gridOptions: any;
  progressTimer: any = null;
  updateStatusCount = 0;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<ImportBlendedModelsResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportBlendedModelsResultGridLayoutService,
    public modelsService: ModelsService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.modelsService.saveImportedBlendedModelsAsynch(this.data).subscribe((data: any) => {
      this.progressTimer && clearTimeout(this.progressTimer);
      if (data && data.responseUtilityMap)
        this.actionStatusCheckIntervalStart(data.responseUtilityMap.statusId);
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });

    this.close();
  }

  importBlendedModelDone(data: any) {
    if(data.responseStatus=== "SUCCESS") {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'success',
        summary: "Import Blended Models",
        detail: data.responseData.importedModelCount + " Blended model was sucessfully imported (highlighted below). "+data.responseData.newModelCount +" new model was added . "+data.responseData.replacedModelCount+" existing models were overwritten."
      });
      this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    }
    // else{
    //   this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
    //     severity: 'error',
    //     summary: "Import Blended Models",
    //     detail: " An error occurred processing your request."
    //   });
    // }
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.modelsService.saveImportedBlendedModelsStatus(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse.responseData;
        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap  && statusResponse.responseUtilityMap.requestStatus)
          reqStatus = statusResponse.responseUtilityMap.requestStatus.toUpperCase();
        if (reqStatus === 'FAILED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION')
            this.showStaleDataDialog();
          else
            this.actionStatusCheckFailed();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
          if (this.isUiTest)
            timeout = 0;
          this.updateStatusCount++;
          this.progressTimer = setTimeout(() => {
            this.actionStatusCheckIntervalStart(statusId);
          }, timeout);
        }

        if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.progressTimer && clearTimeout(this.progressTimer);

          this.importBlendedModelDone(statusResponse.responseData);
        }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.progressTimer && clearTimeout(this.progressTimer);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.progressTimer && clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  showStaleDataDialog() {
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to import models which were modified by another user. Please refresh page to see latest changes.",
      onProceed: () => {
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
    });
  }

  ngOnDestroy() {
    this.progressTimer && clearTimeout(this.progressTimer);
  }
}
